export default class Language {
    userSelectedLanguage = false;

    constructor() {
        if (document.querySelector('#google_translate_element')) {
            setTimeout(() => {
                this.transitionAfterPageLoad();
            }, 300);
            setTimeout(() => {
                this.googleTranslateElementInit();
                this.loadStoredLanguage();

                const skiptranslate = document.querySelector('.skiptranslate');

                if (skiptranslate) {
                    skiptranslate.style.display = 'none';
                    document.body.style.top = '0';
                }
            }, 1000);

            let elementRemoved = false;
        }
    }

    transitionAfterPageLoad() {
        document.querySelector("body").classList.remove("no-transition");
    }
    googleTranslateElementInit() {
        new google.translate.TranslateElement({
            pageLanguage: 'nl',
            layout: google.translate.TranslateElement.InlineLayout.SIMPLE
        }, 'google_translate_element');
    }

    handleLanguage(language, imagePath, languageName) {
        console.log(language, imagePath, languageName);
        let selectField = document.querySelector("select.goog-te-combo");
        if (selectField) {
            selectField.value = language;
            selectField.dispatchEvent(new Event('change'));
        }

        // document.getElementById("currentLanguage").textContent = languageName;
        document.getElementById("currentLanguageImg").src = imagePath;
        document.getElementById("currentLanguageImg").alt = languageName;

        if (language !== 'nl') {
            sessionStorage.setItem('selectedLanguage', JSON.stringify({
                language: language,
                imagePath: imagePath,
                languageName: languageName
            }));
        } else {
            sessionStorage.removeItem('selectedLanguage');
        }

        // Set the userSelectedLanguage flag
        this.userSelectedLanguage = true;
        sessionStorage.setItem('userSelectedLanguage', true);

        setTimeout(() => {
            const skiptranslate = document.querySelector('.skiptranslate');

            if (skiptranslate) {
                skiptranslate.style.display = 'none';
                document.body.style.top = '0';
            }
        }, 1000);
    }

    loadStoredLanguage() {
        const storedLang = sessionStorage.getItem('selectedLanguage');
        const userSelectedLanguage = sessionStorage.getItem('userSelectedLanguage');

        if (storedLang && userSelectedLanguage) {
            const {language, imagePath, languageName} = JSON.parse(storedLang);
            this.handleLanguage(language, imagePath, languageName);
        }
    }

    changeLanguage(language, imagePath, languageName) {
        this.handleLanguage(language, imagePath, languageName);
    }
}

const languageInstance = new Language();
window.changeLanguage = (language, imagePath, languageName) => languageInstance.changeLanguage(language, imagePath, languageName);
